import React, { useEffect, useState } from "react";
import { Button, Skeleton, Grid } from "@mui/material";
import { ForecastReviewGrid } from "../../Components/ForecastReviewGrid";
import ProductMultiSelection from "../../Components/ProductMultiSelection";
import { useForecastReviewContext } from "../../Contexts/forecastReviewContext";
import { useDistributorsContext } from "../../Contexts/distributorsContext";
import { useInternalSkuContext } from "../../Contexts/internalSkuContext";
import { CustomerType } from "../../Enums/CustomerType";
import { useProductsContext } from "../../Contexts/productsContext";
import DistributorMultiselection from "../../Components/DistributorMultiSelection";
import InternalSkuMultiSelection from "../../Components/InternalSkuMultiSelection";
import PropTypes from 'prop-types';
import { SKU_LOCAL_STORAGE_KEY, DISTRIBUTOR_LOCAL_STORAGE_KEY, INTERNAL_SKU_LOCAL_STORAGE_KEY } from "../../Utilities/constants.ts";
import FileUpload from "../../Components/FileUpload";
import InfoDialog from './dialogs/InfoDialog';
import ErrorDialog from './dialogs/ErrorDialog';
import ImportSuccessDialog from './dialogs/ImportSuccessDialog';
import { buildForecastUploadTemplateCsv } from "../../Utilities/forecastUploadTemplateCsv";

export const ForecastReview = ({
  editableWeeksStartIndex,
  editableWeeksEndIndex,
  startWeek,
  endWeek
}) => {
  const { selectedDistributors, setSelectedDistributors } = useDistributorsContext();
  const { selectedProducts, setSelectedProducts } = useProductsContext();
  const { selectedInternalSkus, setSelectedInternalSkus } = useInternalSkuContext();
  const { isReady: areForecastReviewItemsReady, forecastReviewItems, getFormattedOriginalForecastReviewItems, setForecastReviewItems, get } = useForecastReviewContext();
  const [exporting, setExporting] = useState(false);
  const [importSuccessDialogOpen, setImportSuccessDialogOpen] = useState(false);
  const [importSuccessData, setImportSuccessData] = useState(null);

  useEffect(() => {
    const storedSku = localStorage.getItem(SKU_LOCAL_STORAGE_KEY)
    if (storedSku) {
      setSelectedProducts(JSON.parse(storedSku));
    }

    const storedDistributor = localStorage.getItem(DISTRIBUTOR_LOCAL_STORAGE_KEY)
    if (storedDistributor && storedDistributor !== "undefined") {
      setSelectedDistributors(JSON.parse(storedDistributor));
      get();
    }

    const storedInternalSku = localStorage.getItem(INTERNAL_SKU_LOCAL_STORAGE_KEY);
    if (storedInternalSku) {
      setSelectedInternalSkus(JSON.parse(storedInternalSku));
    }
  }, []);

  useEffect(() => {
    if (selectedDistributors) {
      get();
    }
    localStorage.setItem(DISTRIBUTOR_LOCAL_STORAGE_KEY, JSON.stringify(selectedDistributors));
  }, [selectedDistributors, areForecastReviewItemsReady, setSelectedDistributors]);

  const exportForecast = () => {
    setExporting(true);

    let distributors = "";
    selectedDistributors.forEach(distributor => distributors += `distributorIds=${distributor.distributorId}&`);

    let products = "";
    selectedProducts.forEach(product => products += `productSKUs=${product.sku}&`);

    window.open(`api/Distributor/Forecasts/csvFile?${distributors}${products}`);

    setExporting(false);
  };

  useEffect(() => {
    if (forecastReviewItems?.length === 0) {
      const selectedSKUs = selectedProducts?.map(selectedProduct => selectedProduct.sku);
      let items = getFormattedOriginalForecastReviewItems();
      if (selectedSKUs?.length > 0) {
        items = items.filter(forecastReviewItem => selectedSKUs.includes(forecastReviewItem.product.sku));
      }
      if (selectedInternalSkus?.length > 0) {
        items = items.filter((forecastReviewItem) =>
          selectedInternalSkus.some(
            (s) =>
              s.internalSku === forecastReviewItem.customerPartNumber &&
              s.sapId === forecastReviewItem.distributorSapId &&
              s.sku === forecastReviewItem.product?.sku
          )
        );
      }
      setForecastReviewItems(items);
      localStorage.setItem(SKU_LOCAL_STORAGE_KEY, JSON.stringify(selectedProducts));
    }
  }, [selectedProducts, selectedInternalSkus, areForecastReviewItemsReady, setSelectedProducts]);

  return (
    <React.Fragment>
      <Grid container columnSpacing={2} paddingLeft={2} paddingTop={2} justifyContent="end" alignItems="center">
        <Grid item xs={3}>
          <DistributorMultiselection
            customerType={CustomerType.VMI}
            filterByCanOrderBeer={true}
            onClose={() => get()}
          />
        </Grid>
        <Grid item xs={3}>
          <InternalSkuMultiSelection />
        </Grid>
        <Grid item xs={3}>
          <ProductMultiSelection />
        </Grid>
        <Grid item xs={3}>
          <Grid container columnSpacing={2} paddingRight={10} justifyContent="end" alignItems="center">
            <Grid item xs={6}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {/*<FileUpload*/}
                {/*  uploadUrl="api/Distributor/Forecasts/import"*/}
                {/*  buttonText="Upload Forecasts"*/}
                {/*  accept=".csv"*/}
                {/*  templateDownloadFileName="ForecastUploadTemplate.csv"*/}
                {/*  templateDownloadTooltip="Download template"*/}
                {/*  getTemplateDownloadContent={() => buildForecastUploadTemplateCsv({ numberOfWeeks: 8 })}*/}
                {/*  onSuccess={(responseData) => {*/}
                {/*    get();*/}
                {/*    if (responseData && (responseData.message != null || responseData.updatedCount != null)) {*/}
                {/*      setImportSuccessData(responseData);*/}
                {/*      setImportSuccessDialogOpen(true);*/}
                {/*    }*/}
                {/*  }}*/}
                {/*  InfoDialogComponent={InfoDialog}*/}
                {/*  ErrorDialogComponent={ErrorDialog}*/}
                {/*  size="small"*/}
                {/*/>*/}
              </div>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="outlined"
                disabled={forecastReviewItems.length === 0}
                onClick={() => {
                  setForecastReviewItems([]);
                  get();
                }}
                style={{ marginLeft: "80%" }}
              >
                Reset
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="outlined"
                disabled={forecastReviewItems.length === 0 && !exporting}
                onClick={exportForecast}
                style={{ marginLeft: "80%" }}
              >
                Export
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {!selectedDistributors || !areForecastReviewItemsReady ? (
        selectedDistributors && !areForecastReviewItemsReady ? (
          <Skeleton variant="rectangular" height={400} />
        ) : (
          <center style={{ padding: 25 }}>
            <h4>Please select a distributor to review their forecast</h4>
          </center>
        )
      ) : forecastReviewItems.length === 0 ? (
        <center style={{ padding: 25 }}>
          <h4>There is no forecast data for the selected filter</h4>
          <h5>
            If you believe this is an error, please contact your business
            partner or the helpdesk at
            <a href="mailto: customerservice@bostonbeer.com"> customerservice@bostonbeer.com</a>
          </h5>
        </center>
      ) : (
        <ForecastReviewGrid editableWeeksStartIndex={editableWeeksStartIndex} editableWeeksEndIndex={editableWeeksEndIndex} startWeek={startWeek} endWeek={endWeek} isHistorical={false} />
      )}
      <ImportSuccessDialog
        open={importSuccessDialogOpen}
        onClose={() => setImportSuccessDialogOpen(false)}
        successData={importSuccessData}
      />
    </React.Fragment >
  );
};

ForecastReview.propTypes = {
  editableWeeksStartIndex: PropTypes.number,
  editableWeeksEndIndex: PropTypes.number,
  startWeek: PropTypes.number,
  endWeek: PropTypes.number
}